var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89098 6.57034L11.7762 2.1117C11.9173 2.04089 12.0836 2.04089 12.2247 2.1117L21.1099 6.57034C21.4775 6.75484 21.4775 7.27963 21.1099 7.46412L12.2247 11.9228C12.0836 11.9936 11.9173 11.9936 11.7762 11.9228L2.89098 7.46412C2.52332 7.27963 2.52332 6.75484 2.89098 6.57034Z",
    fill: "#E5E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00042 12.5189L11.7762 16.9227C11.9173 16.9935 12.0836 16.9935 12.2247 16.9227L21.0004 12.5189M3.00042 17.4829L11.7762 21.8866C11.9173 21.9574 12.0836 21.9574 12.2247 21.8866L21.0004 17.4829M11.7762 2.1117L2.89098 6.57034C2.52332 6.75484 2.52332 7.27963 2.89098 7.46412L11.7762 11.9228C11.9173 11.9936 12.0836 11.9936 12.2247 11.9228L21.1099 7.46412C21.4775 7.27963 21.4775 6.75484 21.1099 6.57034L12.2247 2.1117C12.0836 2.04089 11.9173 2.04089 11.7762 2.1117Z",
    stroke: "#8278F0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllTab);
export default __webpack_public_path__ + "static/media/all_tab.6b00fb50af2929de553066fe4badf6c7.svg";
export { ForwardRef as ReactComponent };